export const AUTH_BASEURL = "https://1gbdpnb8i2.execute-api.ap-northeast-1.amazonaws.com";
export const USER_PRODUCT_BASEURL = "https://ajuzvl21c7.execute-api.ap-northeast-1.amazonaws.com";
export const USER_ADMIN_BASEURL = "https://7pvno5jo7i.execute-api.ap-northeast-1.amazonaws.com";
export const USER_USER_BASEURL = "https://3o6uximrsd.execute-api.ap-northeast-1.amazonaws.com";
export const TENANT_API_BASEURL = "https://fm7r32ryg2.execute-api.ap-northeast-1.amazonaws.com";

export const USERPOOL_ID = "ap-northeast-1_MGQc96tHB";
export const APPCLIENT_ID = "34pb0jjf5vq7n9q86p5v5pipo8";

